import {Directive, EventEmitter, HostListener, Input, OnDestroy, Output} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {
  DEAL_PAYROLL_GROUP_SETTINGS_MODAL_OPTIONS, DEAL_PAYROLL_GROUP_SETTINGS_SAVED_RESULT
} from './deal-payroll-group-settings.constants';
import {DealPayrollGroupSettingsComponent} from './deal-payroll-group-settings.component';

@Directive({selector: '[dealPayrollGroupSettingsTrigger]'})
export class DealPayrollGroupSettingsTriggerDirective implements OnDestroy {
  @Output() settingsSaved = new EventEmitter<string>();
  private groupId: string;
  private modalReference: NgbModalRef;
  private destroyed = false;

  @Input()
  set dealPayrollGroupSettingsTrigger(value: string) {
    if (value !== this.groupId) { this.dismissModal(); }
    this.groupId = value;
  }

  get dealPayrollGroupSettingsTrigger(): string { return this.groupId; }

  constructor(private modalService: NgbModal) {}

  @HostListener('click')
  open(): void {
    if (!this.groupId || this.modalReference || this.destroyed) {
      return;
    }
    const groupId = this.dealPayrollGroupSettingsTrigger;
    const modal = this.modalService.open(
      DealPayrollGroupSettingsComponent, DEAL_PAYROLL_GROUP_SETTINGS_MODAL_OPTIONS);
    this.modalReference = modal;
    modal.componentInstance.groupId = groupId;
    modal.result.then(
      (result: string) => this.finishModal(modal, groupId, result),
      () => this.finishModal(modal, groupId, null)
    );
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.dismissModal();
  }

  private finishModal(modal: NgbModalRef, groupId: string, result: string): void {
    if (this.modalReference !== modal || this.groupId !== groupId || this.destroyed) { return; }
    this.modalReference = null;
    if (result === DEAL_PAYROLL_GROUP_SETTINGS_SAVED_RESULT) { this.settingsSaved.emit(groupId); }
  }

  private dismissModal(): void {
    const modal = this.modalReference;
    this.modalReference = null;
    if (modal) { modal.dismiss(); }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/deal-payroll-group-settings/deal-payroll-group-settings-trigger.directive.ts